var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
export var Portal = function (_a) {
    var children = _a.children;
    var mount = document.querySelector('body');
    if (!mount) {
        throw new Error('Body Element not found');
    }
    return createPortal(_jsx("div", __assign({ "data-test": "portal" }, { children: children }), void 0), mount);
};
//# sourceMappingURL=portal.js.map